import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { AddButton } from 'modules/expenses/components/expenses/New/AddButton'

interface Props {
  canCreateExpenses: boolean
  canUsePerDiems: boolean
}
export const EmptyState = ({ canCreateExpenses, canUsePerDiems }: Props) => (
  <Box justifyContent="center" alignItems="center" gap="s16">
    <Icon.Large icon="wallet" color="grey600" />
    <Box alignItems="center">
      <Text.Normal size="300" weight="semibold" color="grey1000">
        {i18n.t('expenses_v2.list.empty_state.add_new')}
      </Text.Normal>
      <Text.Normal size="200">{i18n.t('expenses_v2.list.empty_state.no_expenses')}</Text.Normal>
    </Box>
    <Box>{canCreateExpenses && <AddButton type="primary" canUsePerDiems={canUsePerDiems} />}</Box>
  </Box>
)
